import $ from 'jquery';
import { utils } from '../common/utils';
import type { IDonation, IDonorInfo, IDeliveryInfo, IHonoraryInfo } from '../types';
import { DonationAmount } from './donationamount';
import { DonationPaymentOptions } from './donationpaymentoptions';
import { DonationPayment } from './donationpayment';
import { DonationProgress } from './donationprogress';
import { DonationStatus } from './donationstatus';
import { DonationTabs } from './donationtabs';

export class OnetimeGift implements IDonation {
    private onetimeflow: HTMLElement;
    private $onetimeflow!: JQuery<HTMLElement>;
    private amountcontrol!: DonationAmount;
    private donationProgress!: DonationProgress;
    private donationTabs!: DonationTabs;
    private statusbox!: DonationStatus;
    private payment!: DonationPayment;
    private paymentOptions!: DonationPaymentOptions;
    readonly isCompany: boolean;

    constructor(element: HTMLElement) {
        this.onetimeflow = element;
        this.isCompany = element.getAttribute('data-alz-company') === 'true';
    }

    get DonationElement(): HTMLElement {
        return this.onetimeflow;
    }

    get $DonationElement(): JQuery<HTMLElement> {
        return this.$onetimeflow;
    }

    get Amount(): number {
        return this.amountcontrol.getAmount();
    }

    get PaymentValid(): boolean {
        return this.paymentOptions.paymentValid();
    }

    get PaymentMethod(): string {
        return this.paymentOptions.PaymentMethod;
    }

    get HonoraryInfo(): Record<string, never> {
        return {};
    }

    get DonorInfo(): IDonorInfo {
        return this.paymentOptions.DonorInfo;
    }

    get DeliverOptionsValid(): boolean {
        return true;
    }

    get DeliveryInfo(): Record<string, never> {
        return {};
    }

    get CurrentProgress(): number {
        return this.donationProgress.CurrentStep;
    }

    get StatusBox(): DonationStatus {
        return this.statusbox;
    }

    private setupErrorHandler(): void {
        this.$onetimeflow.on('donationerror', (evt: JQuery.TriggeredEvent) => {
            const detail = (evt.originalEvent as CustomEvent).detail as { error: string };
            this.statusbox.setStatus(detail.error);
            utils.scrollTo(this.statusbox.StatusElement);
        });
    }

    private setupTabs(): void {
        this.donationTabs = new DonationTabs(this);
        this.onetimeflow.addEventListener('stepchanged', () => {
            this.donationProgress.setProgress(this.donationTabs.currentTabStep);
            this.statusbox.clear();
            utils.scrollTo(this.donationProgress.currentElement);
            if (this.donationTabs.onPayment) {
                this.payment.callbackPayment();
            } else {
                this.statusbox.clear();
            }
        });
    }

    private updateUserInterface(): void {
        this.$onetimeflow.find('.lbl-yourgift').html(this.Amount.toLocaleString() + ' kr');
    }

    private initAmountEvents(): void {
        this.$onetimeflow.on('amountchanged', () => {
            this.updateUserInterface();
        });
    }

    initEvents(): void {
        this.$onetimeflow = $(this.onetimeflow);
        this.donationProgress = new DonationProgress(this.$onetimeflow.find('.donation-progress')[0]);
        this.amountcontrol = new DonationAmount(this.onetimeflow);
        this.statusbox = new DonationStatus(this.$onetimeflow.find('.alert'));
        this.paymentOptions = new DonationPaymentOptions(this);
        this.payment = new DonationPayment(this, '/api/donations/onetimedonation', 'onetimegiftreference');
        this.initAmountEvents();
        this.setupTabs();
        this.updateUserInterface();
        this.setupErrorHandler();
    }
}
